module.exports = "/_next/static/images/white-zpay@2x-105731087868310886ccbac09b70dea6.png";